import React from 'react';
import Icon from '@/v1/components/atoms/Icon';

import './Warning.scss';

const Warning = (props) => (
    <Icon iconName="Warning" {...props}>
        <svg viewBox="0 0 15 12.67" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
            <path
                // eslint-disable-next-line
                d="M13.59 13.17H2.41a1.89 1.89 0 01-1.68-1 1.83 1.83 0 01.06-1.89l5.58-8.9a1.94 1.94 0 013.26 0l5.58 8.9a1.83 1.83 0 01.06 1.89 1.9 1.9 0 01-1.68 1zM8 1.5a.93.93 0 00-.78.42l-5.59 8.91a.83.83 0 000 .87.9.9 0 00.8.47h11.16a.9.9 0 00.8-.47.83.83 0 000-.87L8.78 1.92A.93.93 0 008 1.5z"
                transform="translate(-.5 -.5)"
            />
            <path d="M8 4.5a.58.58 0 01.58.58V8a.58.58 0 01-.58.58.58.58 0 01-.58-.58V5.08A.58.58 0 018 4.5z" transform="translate(-.5 -.5)" />
            <path d="M8.58 10.33A.58.58 0 118 9.75a.58.58 0 01.58.58" transform="translate(-.5 -.5)" />
        </svg>
    </Icon>
);

export default Warning;
